import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useUpdateIntervention } from '../../../hooks/TICKET/useTicketInterventions';
import MarkdownEditor from '../../MarkdownEditor/MarkdownEditor';
import { useQueryClient } from "@tanstack/react-query";

const EditIntervention = ({ show, onHide, intervention, ticketId }) => {
    const updateMutation = useUpdateIntervention();
    const queryClient = useQueryClient();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [formData, setFormData] = useState({
        date: '',
        time: '',
        duration: '00:01',
        description: ''
    });

    useEffect(() => {
        if (intervention) {
            const startDate = new Date(intervention.start_date);
            setFormData({
                date: startDate.toISOString().split('T')[0],
                time: startDate.toTimeString().slice(0, 5),
                duration: formatMinutesToTime(intervention.duration),
                description: intervention.description || ''
            });
        }
    }, [intervention, show]);

    const formatMinutesToTime = (totalMinutes) => {
        if (!totalMinutes) return "00:01";
        const h = Math.floor(totalMinutes / 60).toString().padStart(2, '0');
        const m = (totalMinutes % 60).toString().padStart(2, '0');
        return `${h}:${m}`;
    };

    const toUTCString = (dateTimeLocal) => {
        if (!dateTimeLocal) return null;
        const date = new Date(dateTimeLocal);
        const pad = (n) => String(n).padStart(2, "0");
        return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}T${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:00`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const [hours, mins] = formData.duration.split(':').map(Number);
        const durationInMinutes = (hours * 60) + mins;

        const payload = {
            intervention: {
                date_debut: toUTCString(`${formData.date}T${formData.time}`),
                duree: durationInMinutes,
                description: formData.description,
                utilisateur: intervention.user_id || 1
            }
        };

        setIsSubmitting(true);
        try {
            await updateMutation.mutateAsync({
                ticketId,
                interventionId: intervention.id,
                interventionData: payload
            });
            queryClient.invalidateQueries({ queryKey: ["ticket", ticketId] });
            onHide();
        } catch (err) {
            console.error(err);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton className="border-0">
                <Modal.Title className="h5 text-muted">Modification intervention</Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Control
                                type="date"
                                value={formData.date}
                                onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                                required
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Control
                                type="time"
                                value={formData.time}
                                onChange={(e) => setFormData({ ...formData, time: e.target.value })}
                                required
                            />
                        </Col>
                    </Row>

                    <Form.Control
                        type="time"
                        className="mb-3"
                        value={formData.duration}
                        onChange={(e) => setFormData({ ...formData, duration: e.target.value })}
                        required
                    />

                    <Form.Label className="text-muted">Compte-rendu</Form.Label>
                    <MarkdownEditor
                        value={formData.description}
                        onChange={(val) => setFormData({ ...formData, description: val })}
                        rows={4}
                    />
                </Modal.Body>

                <Modal.Footer className="border-0">
                    <Button variant="secondary" disabled={isSubmitting} onClick={onHide}>
                        Annuler
                    </Button>
                    <Button type="submit" variant="warning" disabled={isSubmitting}>
                        {isSubmitting ? "Chargement..." : "Modifier"}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default EditIntervention;